import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, font } = theme.custom;
    return {
        scroll: { overflowX: 'auto', WebkitOverflowScrolling: 'touch' },
        mono: { fontFamily: font.mono, fontSize: 13, whiteSpace: 'nowrap' },
        nowrap: { whiteSpace: 'nowrap' },
        numeric: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
        link: {
            fontWeight: 600,
            color: color.text.primary,
            textDecoration: 'none',
            '&:hover': { color: color.primary.main, textDecoration: 'underline' },
        },
        actions: { display: 'flex', gap: 6, justifyContent: 'flex-end', flexWrap: 'wrap', minWidth: 240 },
        skeletons: { padding: 16, display: 'grid', gap: 10 },
        hint: { fontSize: 12, color: color.text.secondary, margin: '0 0 12px' },
        errors: { margin: 0, paddingLeft: 18 },
    };
});
